import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OverlayRef, OverlayService } from '@platform/overlay/overlay.service';

@Component({
  selector: 'app-drawer-base',
  templateUrl: './drawer-base.component.html',
  styleUrls: ['./drawer-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerBaseComponent {
  @Input({ required: true }) opened: boolean;
  @Input() position: 'start' | 'end' = 'start';

  @Output() closed = new EventEmitter<object>();

  private overlayRef: OverlayRef | null = null;

  constructor(private overlayService: OverlayService) {}

  open() {
    this.overlayRef = this.overlayService.open();
  }

  close() {
    if (this.overlayRef) {
      this.overlayService.close(this.overlayRef);
      this.overlayRef = null;
    }

    this.closed.emit({});
  }
}
